import { useEffect } from 'react';
import { useSiteContent } from '../context/SiteContentContext';

// Page titles in both languages
const pageTitles = {
  home: {
    en: 'Tetralog Ltd. | International Transport & Logistics',
    bg: 'Тетралог ЕООД | Международен Транспорт и Логистика'
  },
  about: {
    en: 'About Us | Tetralog Ltd.',
    bg: 'За Нас | Тетралог ЕООД'
  },
  services: {
    en: 'Our Services | Tetralog Ltd.',
    bg: 'Нашите Услуги | Тетралог ЕООД'
  },
  fleet: {
    en: 'Our Fleet | Tetralog Ltd.',
    bg: 'Нашият Флот | Тетралог ЕООД'
  },
  destinations: {
    en: 'Destinations | Tetralog Ltd.',
    bg: 'Дестинации | Тетралог ЕООД'
  },
  whyChooseUs: {
    en: 'Why Choose Us | Tetralog Ltd.',
    bg: 'Защо Да Изберете Нас | Тетралог ЕООД'
  },
  faq: {
    en: 'FAQ | Tetralog Ltd.',
    bg: 'Често Задавани Въпроси | Тетралог ЕООД'
  },
  contact: {
    en: 'Contact Us | Tetralog Ltd.',
    bg: 'Контакти | Тетралог ЕООД'
  },
  careers: {
    en: 'Careers | Tetralog Ltd.',
    bg: 'Кариери | Тетралог ЕООД'
  },
  news: {
    en: 'News | Tetralog Ltd.',
    bg: 'Новини | Тетралог ЕООД'
  },
  admin: {
    en: 'Admin Panel | Tetralog Ltd.',
    bg: 'Администрация | Тетралог ЕООД'
  },
  privacyPolicy: {
    en: 'Privacy Policy | Tetralog Ltd.',
    bg: 'Политика за Поверителност | Тетралог ЕООД'
  },
  termsOfService: {
    en: 'Terms of Service | Tetralog Ltd.',
    bg: 'Условия за Ползване | Тетралог ЕООД'
  },
  cookiePolicy: {
    en: 'Cookie Policy | Tetralog Ltd.',
    bg: 'Политика за Бисквитки | Тетралог ЕООД'
  }
};

/**
 * Custom hook to set page title based on language
 * @param {string} pageKey - Key from pageTitles object
 * @param {string} customTitle - Optional custom title to override default
 */
export function usePageTitle(pageKey, customTitle = null) {
  const { language } = useSiteContent();

  useEffect(() => {
    if (customTitle) {
      document.title = customTitle;
    } else if (pageTitles[pageKey]) {
      document.title = language === 'bg' ? pageTitles[pageKey].bg : pageTitles[pageKey].en;
    }
  }, [pageKey, customTitle, language]);
}

export default usePageTitle;
